
import axios from "axios";
import { variablesGlobales } from "../configs/variables";

const getInstanceAxios = () => {
    const axiosInstance = axios.create({
        baseURL: variablesGlobales.urlServiceBackend,
        withCredentials: true // Incluye las credenciales (cookies) en la solicitud
    });
    return axiosInstance
}


export class APIClient {

    //  get = (url, params) => {
    //   return axios.get(url, params);
    // };
    get = (url, params) => {
        let response;
        let axiosInstance = getInstanceAxios();
        let paramKeys = [];

        if (params) {
            Object.keys(params).map(key => {
                paramKeys.push(key + '=' + params[key]);
                return paramKeys;
            });

            const queryString = paramKeys && paramKeys.length ? paramKeys.join('&') : "";
            response = axiosInstance.get(`${url}?${queryString}`, params);
        } else {
            response = axiosInstance.get(`${url}`, params);
        }

        return response;
    };
    /**
     * post given data to url
     */
    create = (url, data) => {
        let axiosInstance = getInstanceAxios();
        return axiosInstance.post(url, data);
    };
    /**
     * Updates data
     */
    update = (url, data) => {
        let axiosInstance = getInstanceAxios();
        return axiosInstance.patch(url, data);
    };

    put = (url, data) => {
        let axiosInstance = getInstanceAxios();
        return axiosInstance.put(url, data);
    };
    /**
     * Delete
     */
    delete = (url, config) => {
        let axiosInstance = getInstanceAxios();
        return axiosInstance.delete(url, { ...config });
    };
}